import { IImage, IVideo } from '@/shared/components/types.ts';
import { CommonContentComponentProps } from '@/shared/types/common-content-components.ts';

export enum BackgroundType {
  Image = 'image',
  Video = 'video',
  Empty = 'empty',
}

interface BackgroundMask {
  color: string;
  opacity: number;
}

export interface BaseBackground {
  type: BackgroundType;
  animate?: boolean;
  mask?: BackgroundMask;
}

export interface EmptyBackground extends BaseBackground {
  type: BackgroundType.Empty;
}

export interface ImageBackground extends BaseBackground {
  type: BackgroundType.Image;
  image: IImage;
}

export interface VideoBackground extends BaseBackground {
  type: BackgroundType.Video;
  video: IVideo;
}

export type Background = EmptyBackground | ImageBackground | VideoBackground;

export interface BackgroundProps extends CommonContentComponentProps {
  background: Background;
  paused?: boolean;
  frozen?: boolean;
  persistent?: boolean;
}
